import * as React from "react";
import { ErrorComponent, Link, rootRouteId, useMatch, useRouter } from "@tanstack/react-router";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { Button } from "@patient-watch/ui";

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
    const router = useRouter();
    const isRoot = useMatch({
        strict: false,
        select: (state) => state.id === rootRouteId,
    });

    console.error(error);

    return (
        <div className="flex flex-col flex-1 justify-center items-center gap-6 p-4 min-w-0">
            <ErrorComponent error={error} />
            <div className="flex flex-wrap items-center gap-2">
                <Button
                    onClick={() => {
                        router.invalidate();
                    }}
                    variant="secondary"
                >
                    Try Again
                </Button>
                {isRoot ? (
                    <Link to="/">
                        <Button variant="secondary">Home</Button>
                    </Link>
                ) : (
                    <Link
                        to="/"
                        onClick={(e) => {
                            e.preventDefault();
                            window.history.back();
                        }}
                    >
                        <Button variant="secondary">Go Back</Button>
                    </Link>
                )}
            </div>
        </div>
    );
}
